export default __webpack_public_path__ + "static/media/2411.48378fc8.png";